// utils/getKhmerMonthYear.ts
import moment from 'moment';

const khmerMonths = [
  'មករា',     // January
  'កុម្ភៈ',    // February
  'មីនា',     // March
  'មេសា',     // April
  'ឧសភា',     // May
  'មិថុនា',    // June
  'កក្កដា',     // July
  'សីហា',     // August
  'កញ្ញា',     // September
  'តុលា',     // October
  'វិច្ឆិកា',   // November
  'ធ្នូ',      // December
];

const toKhmerNumber = (num) => {
  const khmerDigits = ['០', '១', '២', '៣', '៤', '៥', '៦', '៧', '៨', '៩'];
  return num
    .toString()
    .split('')
    .map(d => (/\d/.test(d) ? khmerDigits[+d] : d))
    .join('');
};

export const getKhmerYear = (date) => {
  const m = moment(date);
  return toKhmerNumber(m.year());
};

export const getKhmerDate = (date) => {
  const m = moment(date);
  return toKhmerNumber(m.date());
};


export const getKhmerMonth = (date) => {
  const m = moment(date);
  return khmerMonths[m.month()]
};
